import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'Atlas visual del 5 moderno',
  value: '$6.500',
  image: 'https://cdn.magicpatterns.com/uploads/rXvQjJ5V7aFihp8XMPqtwu/Captura_de_pantalla_2026-05-22_115410.png'
}, {
  title: '30 ejercicios específicos para mediocampistas defensivos',
  value: '$8.900',
  image: 'https://cdn.magicpatterns.com/uploads/t7VRdvmXChU2hA5kwz1a2c/image.png'
}, {
  title: 'Plan de entrenamiento físico de 8 semanas',
  value: '$12.000',
  image: 'https://cdn.magicpatterns.com/uploads/wykgVQjiWZDoKcDYpEBS1v/image.png'
}, {
  title: 'Planilla de análisis de partidos',
  value: '$4.500',
  image: 'https://cdn.magicpatterns.com/uploads/rhLNqCe82T75L3SZob2dQJ/image.png'
}, {
  title: 'Guía de estudio de mediocampistas profesionales',
  value: '$5.900',
  image: 'https://cdn.magicpatterns.com/uploads/5aCzGbQeSHAzqNx11Bg4jm/image.png'
}, {
  title: 'Las 10 formaciones más usadas y sus tácticas',
  value: '$7.500',
  image: 'https://cdn.magicpatterns.com/uploads/vNhWRLPixQdKCu3W1vsnHc/image.png'
}, {
  title: 'Fuerza, estabilidad y prevención de lesiones',
  value: '$6.900',
  image: 'https://cdn.magicpatterns.com/uploads/msKKXPFDHNdu8ZxPvtZnEv/image.png'
}];
export function Bonuses() {
  return <section className="py-12 px-4 bg-white relative overflow-hidden" data-id="element-12">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-green/5 rounded-full blur-[100px] pointer-events-none" data-id="element-13"></div>

      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="text-center mb-8" data-id="element-15">
          <div className="inline-block bg-brand-greenSoft text-brand-green font-bold px-4 py-1 rounded-full mb-4 animate-pulse border border-brand-green/30" data-id="element-16">
            SOLO HOY
          </div>
          <h2 className="font-display text-4xl md:text-6xl tracking-wide text-brand-text" data-id="element-17">
            BONOS <span className="text-brand-green" data-id="element-18">GRATIS</span> POR HOY
          </h2>
          <p className="text-xl text-brand-muted mt-4" data-id="element-19">
            Estos 7 bonos son{' '}
            <strong className="text-brand-text" data-id="element-20">100% GRATIS</strong> si compras
            hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-21">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white border border-brand-green/30 rounded-xl flex flex-col relative overflow-hidden shadow-sm hover:shadow-lg transition-shadow" data-id="element-22">
              <div className="absolute top-2 right-2 z-20 bg-brand-green text-white font-bold text-[10px] px-2 py-0.5 rounded-md shadow-md" data-id="element-23">
                <span className="line-through opacity-80" data-id="element-24">{bonus.value}</span>{' '}
                GRATIS
              </div>

              {/* Preview image with gradient fade into the title block */}
              <div className="relative w-full h-44 md:h-52 overflow-hidden bg-brand-surface" data-id="element-25">
                <img src={bonus.image} alt={`Vista previa Bono ${index + 1}`} className="w-full h-full object-cover object-top" data-id="element-26" />
                <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-b from-transparent via-white/70 to-white pointer-events-none" data-id="element-27"></div>
              </div>

              <div className="px-5 pb-5 pt-1 -mt-8 relative z-10" data-id="element-28">
                <h3 className="text-base md:text-lg font-bold text-brand-text leading-tight" data-id="element-29">
                  <span className="text-brand-green mr-1" data-id="element-30">
                    Bono {index + 1} —
                  </span>
                  {bonus.title}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}